export default __webpack_public_path__ + "static/media/ButtonRush.a9ab732c.png";